import { ng } from "@common/ngds";

// Bar and link diameters are stored in millimetres by some editors and in metres by others, so any
// magnitude above 1 is read as millimetres. Section lengths and bar coordinates are in metres.
export const normalizeSectionLength = (value: number): number => {
  const num = Number(value);
  if (!Number.isFinite(num)) {
    return 0;
  }

  return Math.abs(num) > 1 ? num * 1.0e-3 : num;
};

/** The concrete outline in the section frame the bar coordinates use: origin at the centroid. */
export type SectionGeometry = {
  minY: number;
  maxY: number;
  minZ: number;
  maxZ: number;
  radius: number;
  circular: boolean;
};

export const getSectionGeometry = (section: ng.sections.Section | null): SectionGeometry | null => {
  const params: any = (section as any)?.params;
  if (!params?.type) {
    return null;
  }

  switch (params.type) {
    case "rParams": {
      const width = Number(params.rParams?.width ?? 0);
      const height = Number(params.rParams?.height ?? 0);
      return {
        minY: -width / 2,
        maxY: width / 2,
        minZ: -height / 2,
        maxZ: height / 2,
        radius: 0,
        circular: false,
      };
    }
    case "sParams": {
      const side = Number(params.sParams?.side ?? 0);
      return {
        minY: -side / 2,
        maxY: side / 2,
        minZ: -side / 2,
        maxZ: side / 2,
        radius: 0,
        circular: false,
      };
    }
    case "cParams": {
      const diameter = Number(params.cParams?.diameter ?? 0);
      return {
        minY: -diameter / 2,
        maxY: diameter / 2,
        minZ: -diameter / 2,
        maxZ: diameter / 2,
        radius: diameter / 2,
        circular: true,
      };
    }
    default:
      return null;
  }
};
